if (!customElements.get('shipping-calculate-div')) {
    customElements.define('shipping-calculate-div', class ShippingCalculateModal extends ModalDialog {
        constructor() {
            super();
        }

        hide(preventFocus = false) {
            super.hide();
        }

        show(opener) {
            super.show(opener);
        }
    });
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true, subtree: true
        });
    });
}

function handleCountryChange() {
    const provinceSelect = document.getElementById("shipping-province")

    const selected = document.getElementById("shipping-country").options[document.getElementById("shipping-country").selectedIndex]
    // if (selected.value === "Australia" && JSON.parse(selected.dataset.provinces).length > 0) {
    //     JSON.parse(selected.dataset.provinces).forEach((province) => {
    //         if (province.length === 2) {
    //             provinceSelect.options[provinceSelect.options.length] = new Option(province[0], province[1]);
    //         }
    //     })
    //     document.getElementById("shipping-province-select-div").classList.remove('hidden')
    // } else {
    //     while (provinceSelect.options.length > 0) {
    //         provinceSelect.remove(0);
    //     }
    //     document.getElementById("shipping-province-select-div").classList.add('hidden')
    // }
    while (provinceSelect.options.length > 0) {
        provinceSelect.remove(0);
    }
    document.getElementById("shipping-province-select-div").classList.add('hidden')
}

waitForElm('#shipping-country').then((elm) => {
    elm.onchange = handleCountryChange

    let australiaIndex;
    let newzealandIndex;

    if (elm.options) {
        Array.from(elm.options).forEach(
            (value, index) => {
                if (value.value === 'Australia' && australiaIndex === undefined) {
                    australiaIndex = index
                }
                if (value.value === 'New Zealand' && newzealandIndex === undefined) {
                    newzealandIndex = index
                }
            }
        )
        if (newzealandIndex !== undefined && australiaIndex !== undefined){
            elm.add(elm.options[newzealandIndex], australiaIndex + 1)
        }
    }

    if (elm.dataset.default) {
        elm.value = elm.dataset.default
    }
});

function findDetails(country, province) {
    const countryToProvinceToZip = {
        "Australia": {
            "Australian Capital Territory": "2617",
            "New South Wales": "2800",
            "Northern Territory": "0870",
            "Queensland": "4818",
            "South Australia": "5250",
            "Tasmania": "7250",
            "Victoria": "3180",
            "Western Australia": "6163"
        }, "United States": {
            "Virginia": "20152"
        }, "Canada": {
            "Quebec": "J7K4C4"
        }, "United Kingdom": {
            "England": "GL4 5LF"
        }, "Austria": {
            "Wien": "1220"
        }, "Bahrain": {
            "": ""
        }, "Bangladesh": {
            "": "1212"
        }, "Belgium": {
            "Wallonie": "4000"
        }, "Brunei": {
            "": "KA 2931"
        }, "Bulgaria": {
            "": "4016"
        }, "China": {
            "Beijing": "100071"
        }, "Croatia": {
            "": "52100"
        }, "Cyprus": {
            "": "1056"
        }, "Czech Republic": {
            "": "25082"
        }, "Denmark": {
            "Region Midtjylland": "8700"
        }, "Estonia": {
            "": "49323"
        }, "Fiji": {
            "": ""
        }, "Finland": {
            "": "00300"
        }, "France": {
            "Languedoc-Roussillon": "30820"
        }, "Georgia": {
            "": "4600"
        }, "Germany": {
            "Niedersachsen": "49661"
        }, "Gibraltar": {
            "": "GX111AA"
        }, "Greece": {
            "Attiki": "18233"
        }, "Greenland": {
            "": "3962"
        }, "Hong Kong": {
            "New Territories": ""
        }, "Hungary": {
            "Santa Cruz de Tenerife": "2721"
        }, "Iceland": {
            "": "109"
        }, "India": {
            "Karnataka": "560100"
        }, "Indonesia": {
            "Jakarta": "14350"
        }, "Ireland": {
            "Dublin": "A94 YE14"
        }, "Isle Of Man": {
            "Isle of Man": "IM6 1AZ"
        }, "Israel": {
            "Haifa": "2630278"
        }, "Italy": {
            "Bologna": "40068"
        }, "Japan": {
            "Chiba": "2790022"
        }, "Kuwait": {
            "": "47765"
        }, "Latvia": {
            "Rigas rajons": "LV-1046"
        }, "Lebanon": {
            "": "0000"
        }, "Lithuania": {
            "": "03154"
        }, "Luxembourg": {
            "": "L-1244"
        }, "Macao": {
            "": ""
        }, "Malaysia": {
            "Selangor": "43500"
        }, "Malta": {
            "": "ATD2620"
        }, "Netherlands": {
            "": "2802KJ"
        }, "New Caledonia": {
            "": "98860"
        }, "New Zealand": {
            "Canterbury": "8011"
        }, "Norway": {
            "Rogaland": "4070"
        }, "Oman": {
            "": "112"
        }, "Pakistan": {
            "": "54570"
        }, "Philippines": {
            "Cavite": "4107"
        }, "Poland": {
            "": "34-425"
        }, "Portugal": {
            "\u00c9vora": "7005-352"
        }, "Qatar": {
            "": ""
        }, "Romania": {
            "Bucure\u0219ti": "011194"
        }, "Russia": {
            "Moscow": "119333"
        }, "Saudi Arabia": {
            "": "11564"
        }, "Serbia": {
            "": "11420"
        }, "Singapore": {
            "": "762348"
        }, "Slovenia": {
            "": "8000"
        }, "South Africa": {
            "Eastern Cape": "6045"
        }, "South Korea": {
            "Gyeonggi": "10869"
        }, "Spain": {
            "Madrid": "28019"
        }, "Sweden": {
            "": "62142"
        }, "Switzerland": {
            "Kanton Bern": "3600"
        }, "Taiwan": {
            "": "81278"
        }, "Thailand": {
            "Bangkok": "10260"
        }, "Turkey": {
            "": "26200"
        }, "Ukraine": {
            "": "36023"
        }, "United Arab Emirates": {
            "Dubai": ""
        }, "Vietnam": {
            "": "700000"
        }, "Afghanistan": {
            "": "1352"
        }, "Aland Islands": {
            "": "22160"
        }, "Albania": {
            "": "1000"
        }, "Andorra": {
            "": "AD200"
        }, "Armenia": {
            "": "0301"
        }, "Azerbaijan": {
            "": "AZ1000"
        }, "Belarus": {
            "": "220030"
        }, "Bhutan": {
            "": "31101"
        }, "Bosnia And Herzegovina": {
            "": "70000"
        }, "British Indian Ocean Territory": {
            "": "96595"
        }, "Cambodia": {
            "": "120401"
        }, "Christmas Island": {
            "": "B1T"
        }, "Cocos (Keeling) Islands": {
            "": "6799"
        }, "Cook Islands": {
            "": ""
        }, "Faroe Islands": {
            "": "927"
        }, "French Polynesia": {
            "": "98709"
        }, "Guadeloupe": {
            "": "97112"
        }, "Iraq": {
            "": ""
        }, "Jordan": {
            "": "11180"
        }, "Kazakhstan": {
            "": "020000"
        }, "Kiribati": {
            "": "KI0107"
        }, "Kosovo": {
            "": "10040"
        }, "Kyrgyzstan": {
            "": "720004"
        }, "Lao People's Democratic Republic": {
            "": "01160"
        }, "Liechtenstein": {
            "": "9493"
        }, "Maldives": {
            "": "20012"
        }, "Mayotte": {
            "": "97630"
        }, "Moldova, Republic of": {
            "": "MD-2001"
        }, "Monaco": {
            "": "98000"
        }, "Mongolia": {
            "": "22011"
        }, "Myanmar": {
            "": "11051"
        }, "Nauru": {
            "": "804417"
        }, "Nepal": {
            "": "44600"
        }, "Niue": {
            "": "9974"
        }, "Norfolk Island": {
            "": "2899"
        }, "North Macedonia": {
            "": "1000"
        }, "Palestinian Territory, Occupied": {
            "": ""
        }, "Papua New Guinea": {
            "": "611"
        }, "Pitcairn": {
            "": "15140"
        }, "San Marino": {
            "": "47892"
        }, "Slovakia": {
            "": "974 01"
        }, "Solomon Islands": {
            "": ""
        }, "Sri Lanka": {
            "": "10513"
        }, "Svalbard And Jan Mayen": {
            "": "8099"
        }, "Tajikistan": {
            "": "735"
        }, "Timor Leste": {
            "": ""
        }, "Tokelau": {
            "": ""
        }, "Tonga": {
            "": ""
        }, "Turkmenistan": {
            "": "745180"
        }, "Tuvalu": {
            "": ""
        }, "Uzbekistan": {
            "": "100214"
        }, "Vanuatu": {
            "": "00000"
        }, "Holy See (Vatican City State)": {
            "": "00120"
        }, "Wallis And Futuna": {
            "": "98600"
        }, "Yemen": {
            "": ""
        }
    }

    try {
        if (country === "Australia") {
            if (province && countryToProvinceToZip[country].hasOwnProperty(province)) {
                //
            } else {
                // province = "Queensland"
                province = "Victoria"
            }
        } else {
            if (countryToProvinceToZip.hasOwnProperty(country)) {
                province = Object.keys(countryToProvinceToZip[country])[0]
            } else {
                province = ""
            }
        }
        const finalCountry = country
        const finalProvince = province
        const finalZipcode = ((countryToProvinceToZip[finalCountry] || {})[finalProvince]) || ""

        return [finalCountry, finalProvince, finalZipcode]
    } catch (e) {
        return [country, province, ""]
    }
}

function handleCalculation() {
    const button = document.getElementById("shipping-calculate-btn")
    const selectCountry = document.getElementById("shipping-country")
    const selectProvince = document.getElementById("shipping-province")

    button.querySelector('.text').classList.add('hidden')
    button.querySelector('.loading-overlay__spinner').classList.remove('hidden')

    button.disabled = true
    selectCountry.disabled = true
    selectProvince.disabled = true
    document.getElementById("shipping-rate-estimate").classList.add('hidden')

    const country = selectCountry.value;
    let province;

    if (country === 'Australia') {
        // province = selectProvince.value
        // province = 'Queensland'
        province = 'Victoria'
    } else {
        province = ''
    }

    const [postCountry, postProvince, postZip] = findDetails(country, province)

    document.getElementById("shipping-rates").classList.add('hidden')
    document.getElementById("shipping-rates").innerHTML = ""


    fetch("/cart/shipping_rates.json", {
        "headers": {
            "accept": "*/*",
            "accept-language": "en-US,en;q=0.9",
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
            "x-requested-with": "XMLHttpRequest"
        }, "body": new URLSearchParams({
            "shipping_address[country]": postCountry,
            "shipping_address[province]": postProvince,
            "shipping_address[zip]": postZip,
        }), "method": "POST", "mode": "cors", "credentials": "include"
    }).then(function (response) {
        return response.json()
    })
        .then(function (result) {
            let shipping_rates;

            if (result.hasOwnProperty('shipping_rates')) {
                shipping_rates = result.shipping_rates
            } else {
                shipping_rates = null
            }

            if (shipping_rates) {
                if (shipping_rates.length > 0) {
                    let rate = 999999999999.99
                    result.shipping_rates.forEach(
                        (res) => {
                            rate = Math.min(rate, res["price"])
                        }
                    )
                    let span = document.createElement('span')
                    span.classList.add('rate')
                    span.innerText = "We found " + result.shipping_rates.length + " shipping rates available for " + country + ", starting at " + rate + " " + result.shipping_rates[0]["currency"] + "."
                    document.getElementById("shipping-rates").appendChild(span)

                    result.shipping_rates.forEach(
                        (res) => {
                            let span = document.createElement('span')
                            span.classList.add('rate')
                            span.innerText = "• " + res["name"] + " at " + res["price"] + " " + res["currency"]
                            document.getElementById("shipping-rates").appendChild(span)
                        }
                    )
                } else {
                    let span = document.createElement('span')
                    span.classList.add('error')
                    span.innerText = "• Unfortunately we currently do not ship to " + country +"."
                    document.getElementById("shipping-rates").appendChild(span)
                }
            } else {
                if (result.country) {
                    result.country.forEach(
                        (res) => {
                            let span = document.createElement('span')
                            span.classList.add('error')
                            span.innerText = "• " + res
                            document.getElementById("shipping-rates").appendChild(span)
                        }
                    )
                } else {
                    let span = document.createElement('span')
                    span.classList.add('error')
                    span.innerText = "• Some error has occurred, please check the shipping rates at checkout."
                    document.getElementById("shipping-rates").appendChild(span)
                }
            }
        })
        .catch(function (err) {
            let span = document.createElement('span')
            span.classList.add('error')
            span.innerText = "• Some error has occurred, please check the shipping rates at checkout."
            document.getElementById("shipping-rates").appendChild(span)
        }).finally(
        function () {
            button.querySelector('.text').classList.remove('hidden')
            button.querySelector('.loading-overlay__spinner').classList.add('hidden')

            button.disabled = false
            selectCountry.disabled = false
            selectProvince.disabled = false
            document.getElementById("shipping-rates").classList.remove('hidden')
        }
    );
}

function handleAutoCalculation() {
    const selectCountry = document.getElementById("shipping-country")
    const selectProvince = document.getElementById("shipping-province")

    if (selectCountry.dataset.default) {
        const country = selectCountry.value;
        let province;

        if (country === 'Australia') {
            // province = selectProvince.value
            // province = 'Queensland'
            province = 'Victoria'
        } else {
            province = ''
        }

        const [postCountry, postProvince, postZip] = findDetails(country, province)

        fetch("/cart/shipping_rates.json", {
            "headers": {
                "accept": "*/*",
                "accept-language": "en-US,en;q=0.9",
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
                "x-requested-with": "XMLHttpRequest"
            }, "body": new URLSearchParams({
                "shipping_address[country]": postCountry,
                "shipping_address[province]": postProvince,
                "shipping_address[zip]": postZip,
            }), "method": "POST", "mode": "cors", "credentials": "include"
        }).then(function (response) {
            return response.json()
        })
            .then(function (result) {
                if ((result.shipping_rates || []).length > 0) {
                    let rate = 999999999999.99
                    result.shipping_rates.forEach(
                        (res) => {
                            rate = Math.min(rate, res["price"])
                        }
                    )

                    document.getElementById("shipping-rate-estimate").innerText = "Shipping to " + country + " starts at " + rate + " " + result.shipping_rates[0]["currency"] + "."
                    document.getElementById("shipping-rate-estimate").classList.remove('hidden')
                }
            })
            .catch(function (err) {
                console.error(err)
            });
    }
}

waitForElm('#shipping-calculate-btn').then((elm) => {
    elm.onclick = handleCalculation
});
waitForElm('#shipping-rate-estimate').then((elm) => {
    handleAutoCalculation()
});